module.exports = __webpack_public_path__ + "img/building.985a0a87.svg";